import React from 'react';

import Breadcrumbs from '../../components/Breadcrumbs';
import CenteredColumn from '../../components/CenteredColumn';
import PageContent from '../../components/PageContent';
import PageHeader from '../../components/PageHeader';

// import styles from './SingleColumnPage.module.scss';

export default function SingleColumnPage({ children, breadcrumbs, buttons, headerContent }) {
  return (
    <>
      <PageHeader right={buttons && buttons()}>
        {breadcrumbs && <Breadcrumbs>{breadcrumbs()}</Breadcrumbs>}
        {headerContent && headerContent()}
        <div id="tma-report-header-portal" style={{ flex: 1 }}></div>
      </PageHeader>

      <PageContent>
        <CenteredColumn>{children}</CenteredColumn>
      </PageContent>
    </>
  );
}
